import { render, staticRenderFns } from "./CPCallLog.vue?vue&type=template&id=1026798e&scoped=true&"
import script from "./CPCallLog.vue?vue&type=script&lang=js&"
export * from "./CPCallLog.vue?vue&type=script&lang=js&"
import style0 from "./CPCallLog.vue?vue&type=style&index=0&id=1026798e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026798e",
  null
  
)

export default component.exports